module.exports = __webpack_public_path__ + "img/fortebon.5ee55949.jpg";